import { render, staticRenderFns } from "./CaseMenu.vue?vue&type=template&id=864f3060"
import script from "./CaseMenu.vue?vue&type=script&lang=js"
export * from "./CaseMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports